<template>
    <v-container
        class="align-start"
        fill-height
    >
        <div class="row no-gutters" width="100%">
            <v-col>
                <loading-overlay :loading="loading"></loading-overlay>
                <transfers-date-filters
                  title="Payment Received"
                  @filter="loadOrders"
                  @export="onExport"
                />
                <div class="mt-48"></div>
                <v-data-iterator
                    :items="orders"
                    :items-per-page="pagination.transferPerPage"
                    :page.sync="pagination.page"
                    :loading="loading"
                    hide-default-footer
                    @page-count="pagination.pageCount = $event"
                >
                    <template v-slot:item="{ item }">
                        <v-row class="mb-4 no-gutters">
                            <Item :item="item" />
                        </v-row>
                    </template>
                    <template v-slot:footer>
                        <v-pagination
                            v-model="pagination.page"
                            :length="pagination.pageCount"
                            :total-visible="7"
                        />
                    </template>
                </v-data-iterator>
            </v-col>
        </div>
    </v-container>
</template>

<script>
import MySocket from '../services/MySocket';
import Item from './received-payments-item.vue';
import transfersDateFilters from './transfers/components/transfers-date-filter'

export default {
    components: {
        Item,
        transfersDateFilters,
    },
    data() {
        return {
          orders: [],
          loading: false,
          pagination: {
              transferPerPage: 10,
              page: 1,
              pageCount: 0,
          },
        };
    },
    mounted() {
        this.loadOrders();
        MySocket.on('orderUpdated', (order) => {
            if (this.loading) {
                return false;
            }

            const index = this.orders.findIndex((item) => item.id === order.id);
            if (index >= 0) {
                Vue.set(this.orders, index, {
                    ...this.orders[index],
                    ...order,
                });
            }
        });
    },
    beforeDestroy() {
        MySocket.remove('orderUpdated');
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    methods: {
        loadOrders(filters = {}) {
            this.loading = true;
            return Vue.backendApi().order().listReceivedOrders(this.user.id, filters)
                .then((response) => {
                    this.loading = false;
                    this.orders = response.data.models;
                    this.pagination = response.data.pagination;
                })
                .catch((err) => {
                    this.loading = false;
                    this.$swal({
                        type: 'error',
                        title: 'Error loading orders',
                        text: err,
                    });
                });
        },
        onExport(payload) {
            this.loading = true;
            return Vue.backendApi().order().exportReceivedOrders(this.user.id, payload)
                .then((response) => {
                    this.loading = false;
                    const { url } = response.data;
                    window.open(url); // eslint-disable-line
                })
                .catch((err) => {
                    this.loading = false;
                    this.$swal({
                        type: 'error',
                        title: 'Error exporting orders',
                        text: err,
                    });
                });
        },
    },
};
</script>
<style scoped>
    .mt-48 {
        margin-top: 192px !important;
    }
</style>
